import { render, staticRenderFns } from "./setting-emailNotification.vue?vue&type=template&id=46d4edee&scoped=true&"
import script from "./setting-emailNotification.vue?vue&type=script&lang=js&"
export * from "./setting-emailNotification.vue?vue&type=script&lang=js&"
import style0 from "./setting-emailNotification.vue?vue&type=style&index=0&id=46d4edee&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46d4edee",
  null
  
)

export default component.exports